import React, { useState } from "react";

import travel from '../assets/images/travel-train-station.svg'

import Navbar from "../components/navbar";
import Footer from "../components/footer";
import Switcher from "../components/switcher";
import { useToast } from "../context/ToastProvider";
import { postContact } from "../services/api";

import {FiMail} from '../assets/icons/vander'

const EMPTY_FORM = { name: "", email: "", subject: "", message: "", website: "" };

export default function Contact(){
    const toast = useToast();
    const [form, setForm] = useState(EMPTY_FORM);
    const [submitting, setSubmitting] = useState(false);
    const [sent, setSent] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!form.name || !form.email || !form.subject || !form.message) {
            toast.error("Completa nombre, correo, asunto y mensaje.");
            return;
        }
        setSubmitting(true);
        try {
            await postContact(form);
            setSent(true);
            setForm(EMPTY_FORM);
            toast.success("¡Mensaje enviado! Te contactaremos pronto.");
        } catch (err) {
            toast.error(err.message || "No se pudo enviar el mensaje. Intenta más tarde.");
        } finally {
            setSubmitting(false);
        }
    };

    return(
        <>
        <Navbar navclass="defaultscroll is-sticky" navlight={false} manuclass="justify-end"/>
        <section className="relative lg:py-24 py-16 mt-20">
            <div className="container">
                <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-6">
                    <div className="lg:col-span-7 md:col-span-6">
                        <img src={travel} className="w-full max-w-[500px] mx-auto" alt=""/>
                    </div>

                    <div className="lg:col-span-5 md:col-span-6">
                        <div className="lg:ms-5">
                            <div className="bg-white dark:bg-slate-900 rounded-md shadow dark:shadow-gray-800 p-6">
                                <h3 className="mb-6 text-2xl leading-normal font-semibold">Escríbenos</h3>

                                {sent && (
                                    <p className="mb-4 text-green-600 font-medium">
                                        ¡Gracias! Recibimos tu mensaje y te responderemos a la brevedad.
                                    </p>
                                )}

                                <form onSubmit={handleSubmit}>
                                    <div className="grid lg:grid-cols-12 grid-cols-1 gap-3">
                                        <div className="lg:col-span-6">
                                            <label htmlFor="name" className="font-semibold">Tu nombre:</label>
                                            <input name="name" id="name" type="text" autoComplete="name" value={form.name} onChange={handleChange} className="mt-2 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0" placeholder="Nombre" required/>
                                        </div>

                                        <div className="lg:col-span-6">
                                            <label htmlFor="email" className="font-semibold">Tu correo:</label>
                                            <input name="email" id="email" type="email" autoComplete="email" spellCheck={false} value={form.email} onChange={handleChange} className="mt-2 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0" placeholder="Correo electrónico" required/>
                                        </div>

                                        <div className="lg:col-span-12">
                                            <label htmlFor="subject" className="font-semibold">Asunto:</label>
                                            <input name="subject" id="subject" value={form.subject} onChange={handleChange} className="mt-2 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0" placeholder="Asunto" required/>
                                        </div>

                                        <div className="lg:col-span-12">
                                            <label htmlFor="message" className="font-semibold">Tu mensaje:</label>
                                            <textarea name="message" id="message" value={form.message} onChange={handleChange} className="mt-2 w-full py-2 px-3 h-28 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-100 dark:border-gray-800 focus:ring-0" placeholder="Escribe tu mensaje" required></textarea>
                                        </div>

                                        {/* Honeypot anti-spam: oculto para humanos, tentador para bots. */}
                                        <input
                                            type="text"
                                            name="website"
                                            value={form.website}
                                            onChange={handleChange}
                                            tabIndex="-1"
                                            autoComplete="off"
                                            aria-hidden="true"
                                            style={{ position: "absolute", left: "-9999px", width: 1, height: 1, opacity: 0 }}
                                        />
                                    </div>
                                    <button type="submit" id="submit" name="send" disabled={submitting} className={`py-2 px-5 inline-block tracking-wide align-middle duration-500 text-base text-center text-white rounded-md mt-2 ${submitting ? 'bg-red-300 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600'}`}>
                                        {submitting ? 'Enviando…' : 'Enviar mensaje'}
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container lg:mt-24 mt-16">
                <div className="grid grid-cols-1">
                    <div className="text-center px-6">
                        <div className="relative text-transparent">
                            <div className="size-20 bg-red-500/5 text-red-500 rounded-xl text-2xl flex align-middle justify-center items-center mx-auto shadow-sm dark:shadow-gray-800">
                                <FiMail></FiMail>
                            </div>
                        </div>

                        <div className="content mt-7">
                            <h5 className="h5 text-lg font-semibold">Correo</h5>
                            <p className="text-slate-400 mt-3">¿Tienes preguntas sobre un tour o tu reserva? Escríbenos y te respondemos.</p>

                            <div className="mt-5">
                                <a href="mailto:turismo@cmsystem.cl" className="text-red-500 font-medium">turismo@cmsystem.cl</a>
                            </div>
                        </div>
                    </div>
                    {/* TODO negocio: teléfono/dirección reales (no se muestran hasta contar con datos verificados) */}
                </div>
            </div>
        </section>
        <Footer/>
        <Switcher/>
        </>
    )
}
